<template>
  <div class="overlay">
    <div class="page-lock">
      <div class="page-logo">
        <router-link to="/login" class="brand" >
          <img src="/static/pages/img/logo.png" alt="logo">
        </router-link>
      </div>
      <div class="alert alert-danger" v-if="validMessage != ''">
        <button class="close" data-close="alert"></button>
        <span>{{ validMessage }} </span>
      </div>
      <div class="page-body" v-if="!validToken">
          <div class="lock-head" v-if="this.$route.name === 'Remind Token'"> Reset Password</div>
        <div class="lock-head" v-else> Confirmation Account</div>
        <div class="lock-body">
          <div class="lock-cont">
            <div class="lock-item lock-item-full">
              <form class="lock-form pull-left" data-vv-scope="remind-form" v-on:submit.prevent="onSubmit">
                <div class="form-group" :class="{ 'has-error': errors.has('remind-form.Token') }">
                  <input class="form-control placeholder-no-fix" type="hidden" autocomplete="off" placeholder="Token"
                         name="Token" v-model="token" v-validate="'required'">
                  <span v-show="errors.has('remind-form.Token')" class="help-block">{{ errors.first('remind-form.Token') }}</span>
                </div>
                <div class="form-group" :class="{ 'has-error': errors.has('remind-form.New Password') }">
                  <input class="form-control placeholder-no-fix" type="password" autocomplete="off" placeholder="New Password"
                         name="New Password" v-model="password" v-validate="{required:true, min:6, max:16, password: true}">
                  <span v-show="errors.has('remind-form.New Password')" class="help-block">{{ errors.first('remind-form.New Password') }}</span>
                </div>
                <div class="form-group" :class="{ 'has-error': errors.has('remind-form.Confirm New Password') }">
                <input class="form-control placeholder-no-fix" type="password" autocomplete="off" placeholder="Confirm New Password"
                       name="Confirm New Password" v-model="password2" v-validate="{required: true, is: password}" ref="New Password">
                  <span v-show="errors.has('remind-form.Confirm New Password')" class="help-block">{{ errors.first('remind-form.Confirm New Password') }}</span>
                </div>
                <div class="form-actions">
                  <button type="submit" class="btn btn-warning mt-ladda-btn ladda-button check-token"
                          data-style="expand-left">
                    <span class="ladda-label">Submit</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="lock-bottom">
          <router-link v-if="this.$route.name !== 'Remind Token'" to="/login">Already activated?</router-link>
        </div>
      </div>
      <div class="page-footer-custom">&copy; {{ new Date().getFullYear() }} CaseMGR Solutions, Inc. All Rights Reserved.</div>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  export default {
    data() {
      return {
        token: this.$route.params.token,
        password: '',
        password2: ''
      }
    },
    inject: {
      $validator: '$validator'
    },
    mounted() {
      this.checkValidToken({token: this.token, remind: (this.$route.name === 'Remind Token')});
    },
    computed: {
      ...mapGetters({
        validToken: 'getConfirmationError',
        validMessage: 'getConfirmationMessage'
      })
    },
    methods: {
      ...mapActions({
        checkToken: 'CHECK_CONFIRMATION_TOKEN_ACTION',
        passwordChange: 'CHANGE_PASSWORD_ACTION',
        checkValidToken: 'CHECK_VALID_TOKEN_ACTION'
      }),
      onSubmit() {
        const context = Ladda.create(document.querySelector('.check-token'));
        this.$validator.validateAll('remind-form').then((result) => {
          if (result) {
            if (this.$route.name != null) {
              this.passwordChange({token: this.token, password: this.password2, context});
            } else {
              this.checkToken({token: this.token, password: this.password2, context});
            }
          }
        });
      }
    },
  }
</script>
<style scoped>
  .overlay {
    background-color: #ffffff;
    min-height: 100vh;
    min-width: 100vw;
    position: absolute;
  }

  .brand img {
    width: 100%;
  }

  .page-lock .lock-cont {
    width: 100%;
  }

  .lock-form .form-group .form-control {
    width: 100%;
  }

  .lock-form .form-actions .btn {
    width: 100%;
  }

  .lock-form {
    padding-left: 0px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// Confirmation.vue?443b9fde